export default __webpack_public_path__ + "static/media/3.dfd209ec.jpg";